import React from 'react';

const TextLeftComponent = ({ children, imgPCURL, imgMobileURL, row }) => {
    return (
        <div>
            {/* pc */}
            <div className={`hidden-xs hidden-sm text-left-pc ${row}-pc`}>
                <img src={imgPCURL} />
                <div className='content'>
                    <div className='text'>
                        {children}
                    </div>
                </div>
            </div>

            {/* mobile */}
            <div className={`hidden-md hidden-lg text-left-mobile ${row}-mobile`}
                style={{ backgroundImage: imgMobileURL, backgroundSize: 'cover' }}>
                <div className='content'>
                    <div className='text'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default TextLeftComponent


// WEBPACK FOOTER //
// ./src/components/business-solution/textLeftComponent.js